// @mui
import { Box } from '@mui/material';
//
import { Product } from '../../../data/products';
import { CONTAINER } from '../../../theme/stage';
import { ANCHOR, PRODUCTS_SECTION } from '../copy';
import Eyebrow from '../primitives/Eyebrow';
import Reveal from '../primitives/Reveal';
import TwoTone from '../primitives/TwoTone';
import ProductCard from './ProductCard';

// ----------------------------------------------------------------------

type Props = {
  products: Product[];
};

const STAGGER = 80;

export default function Products({ products }: Props) {
  const next = products[products.length - 1].index + 1;

  return (
    <Box
      component="section"
      id={ANCHOR.products}
      aria-labelledby={PRODUCTS_SECTION.titleId}
      sx={{
        pt: { xs: '88px', sm: '160px', lg: '200px' },
        scrollMarginTop: { xs: '-88px', sm: '-160px', lg: '-200px' },
        '&:focus': { outline: 'none' },
      }}
    >
      <Box sx={CONTAINER}>
        <Reveal>
          <Eyebrow>{PRODUCTS_SECTION.eyebrow}</Eyebrow>
        </Reveal>

        <TwoTone
          as="h2"
          id={PRODUCTS_SECTION.titleId}
          lines={PRODUCTS_SECTION.lines}
          size="billboard"
          lineMode="block"
          enter="view"
        />

        <Box
          component="ul"
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              md: 'repeat(2, minmax(0, 1fr))',
              lg: 'repeat(3, minmax(0, 1fr))',
            },
            gap: { xs: '16px', sm: '24px' },
            listStyle: 'none',
            m: { xs: '48px 0 0', sm: '56px 0 0', lg: '64px 0 0' },
            p: 0,
            '& > li': { display: 'grid' },
          }}
        >
          {products.map((product, i) => (
            <li key={product.id}>
              <Reveal y={40} delay={i * STAGGER}>
                <ProductCard variant="live" product={product} />
              </Reveal>
            </li>
          ))}
          <Box component="li" sx={{ gridColumn: { md: '1 / -1', lg: 'auto' } }}>
            <Reveal y={40} delay={products.length * STAGGER}>
              <ProductCard variant="next" index={next} />
            </Reveal>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
